/**
 * WGProfile Page Component - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A comprehensive working group member profile page with advanced features:
 * - Working group member profile display
 * - Dynamic member ID detection from URL parameters and state
 * - Member type specification for working group members
 * - Error handling for missing member information
 * - Profile component integration with member type support
 * - URL parameter and location state management
 * - Loading states and error messaging
 * 
 * Features:
 * - URL parameter and state-based member ID detection
 * - Working group member type specification
 * - MemberProfile component integration
 * - Error handling for missing member IDs
 * - Loading and error state management
 * - Profile CSS styling integration
 * - React Router navigation support
 * 
 * @returns {JSX.Element} WGProfile page component with working group member profile display
 */
import React, { useEffect, useState } from 'react';
import MemberProfile from '../components/Profile/MemberProfile';
import './Profile.css';
import { useLocation, useParams } from 'react-router-dom';

/**
 * WGProfile component for displaying working group member profiles
 * with dynamic member ID detection and error handling
 */
function WGProfile() {
    const location = useLocation();
    const { id } = useParams();
    const [memberId, setMemberId] = useState(null);
    const [memberType, setMemberType] = useState(null);

    useEffect(() => {
        const newMemberId = location.state?.profileData?.id || id;
             
        if (!newMemberId) {
            return;
        }
        setMemberId(newMemberId);
        setMemberType('WorkingGroupMember');
    }, [location.state, id]);


    if (!memberId) {
        return (
            <div className='totalPage' id='profilePage'>
                <section className="wrapper">
                    <div className="container mt-6 pb-6">
                        <div className="error-message">No member ID provided</div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className='totalPage' id='profilePage'>
            <section className="wrapper">
                <div className="container mt-6 pb-6">
                    <MemberProfile memberId={memberId} />
                </div>
            </section>
        </div>
    );
}

export default WGProfile;